import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

import { BaseWebService } from "../shared/services/base-web.service";
import 'rxjs/add/observable/throw';

@Injectable()
export class VCStartService {

    constructor(
        private _basewebservice: BaseWebService
    ) { }

    /**
     * Function for get Ortho calculator details
     */
    vcDetailService(data: any) {
        let token = data.token;
        return this._basewebservice.requestWithUrlToken("v1/va/practice_details/", "get", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Function to send website link to mobile
     */
    sendLinkService(phoneNumber: any, token:any) {
        const data: any = {};
        data.body = {'phone_number': phoneNumber};
        data.token = token;
        return this._basewebservice.requestWithUrlToken("v1/va/link/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }


    /**
     * Function for handling service call errors
     * @param  {Response|any} error contains error data
     */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }

}